const CalendarIcon = ({
  size = 16,
  strokeColor = "#222222",
  color,
  className = "",
  ...props
}) => {
  const fillColor = color || strokeColor;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.8324 18.3332H4.16569C3.24522 18.3332 2.49902 17.587 2.49902 16.6665V4.99984C2.49902 4.07936 3.24522 3.33317 4.16569 3.33317H5.83236V1.6665H7.49902V3.33317H12.499V1.6665H14.1657V3.33317H15.8324C16.7528 3.33317 17.499 4.07936 17.499 4.99984V16.6665C17.499 17.587 16.7528 18.3332 15.8324 18.3332ZM4.16569 8.33317V16.6665H15.8324V8.33317H4.16569ZM4.16569 4.99984V6.6665H15.8324V4.99984H4.16569Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CalendarIcon;
